import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
    button: {
        display: 'flex',
        justifyContent: 'left',
        padding: '4px 28px 4px',
        marginTop: '10px'
    }
})

const LoginButton = () => {
    const styles = useStyles();
    return (
        <input className={styles.button} type="submit" value="Log In"/>
    );
}

export default LoginButton